import React, { Component } from 'react';
import { Modal, Table, Grid, Row, Col, ButtonToolbar, Button } from 'react-bootstrap';
import { PropTypes } from 'prop-types';

import { TableButton } from '../../TableButton';
import { PaginationBuilder } from '../../PaginationBuilder';
import { PaginationHelper } from '../../helpers/PaginationHelper';
import { LoadingSpinner } from '../../LoadingSpinner';
import { HandleMessage } from '../../HandleMessage';
import { PathNoteForm } from './PathNoteForm';

export class PathNotes extends Component {
    static contextTypes = {
        selectApp: PropTypes.func,
        selectedProvider: PropTypes.string
    }

    componentDidMount() {
        this.context.selectApp('datamanager', false);
    }

    constructor(props) {
        super(props);

        this.state = {
            table: {
                data: [],
                page: 1,
                totalPages: 1,
                elementsPerPage: 10
            },
            form: {
                title: undefined,
                note: undefined,
                original: undefined,
            },
            actions: {
                isLoading: true,
                isUpdating: false
            },
            message: {
                show: false,
                message: undefined,
                style: undefined,
                icon: undefined,
                title: ""
            }
        };

        this.getData();
    }

    // ---------------------------

    getData(resetActions = false) {
        if (resetActions) {
            const { actions } = this.state;

            actions.isLoading = true;

            this.setState({
                actions: actions
            });
        }

        this.props.command.getNotes(
            this.props.edition,
            this.props.elementId,
            (a) => this.listSuccessCallback(a),
            (a) => this.operationErrorCallback(a, "isLoading")
        );
    }

    onSave() {
        const { table, actions } = this.state;

        actions.isUpdating = true;

        this.props.command.saveNotes(
            this.props.edition,
            this.props.elementId,
            table.data,
            (a) => this.operationSuccessCallback(a),
            (a) => this.operationErrorCallback(a, "isUpdating")
        );

        this.setState({
            actions: actions
        });
    }

    listSuccessCallback(result) {
        const { table, actions } = this.state;
        const totalPages = PaginationHelper.getTotalPages(result.length, table.elementsPerPage);

        actions.isLoading = false;
        table.data = result;
        if (0 !== totalPages) {
            table.page = table.page > totalPages ? totalPages : table.page;
        }
        else {
            table.page = 1;
        }

        this.setState({
            table: table,
            actions: actions
        });
    }

    operationSuccessCallback(result) {
        const messageObj = {
            message: result.message,
            style: "success",
            title: "Sucesso",
            icon: "ok"
        };

        this.props.onHide(messageObj);
    }

    operationErrorCallback(messageReceived, updateAction) {
        const { actions, message } = this.state;

        actions[updateAction] = false;

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            actions: actions,
            message: {
                show: true,
                message: messageReceived,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    // -----------------------

    onChangePage(pageNumber) {
        const { table } = this.state;
        table.page = pageNumber;

        this.setState({
            table: table
        });
    }

    onChangeElementsPerPage(elementsPerPage) {
        const { table } = this.state;
        const totalPages = PaginationHelper.getTotalPages(table.data.length, elementsPerPage);

        table.elementsPerPage = elementsPerPage;
        if (0 !== totalPages) {
            table.page = table.page > totalPages ? totalPages : table.page;
        }
        else {
            table.page = 1;
        }

        this.setState({
            table: table
        });
    }

    // -----------------------

    onEditClick(note) {
        const { form } = this.state;

        form.original = note;
        form.note = Object.assign({}, note);
        form.title = "Editar";

        this.setState({
            form: form
        });
    }

    onAddClick() {
        const { form } = this.state;

        form.original = null;
        form.note = {
            text: ""
        };
        form.title = "Adicionar";

        this.setState({
            form: form
        });
    }

    onDeleteClick(note) {
        const { table } = this.state;

        table.data = table.data.filter(data => data !== note);

        this.setState({
            table: table
        });
    }

    onNoteSave(note) {
        const { form } = this.state;

        if (null === form.original) {
            const { table } = this.state;
            table.data.push(note);
        }
        else {
            form.original.text = note.text;
        }

        this.onNoteExit();
    }

    onNoteExit() {
        const { form } = this.state;

        form.original = undefined;
        form.note = undefined;
        form.title = undefined;

        this.setState({
            form: form
        });
    }

    // -----------------------

    onExitMessage() {
        this.setState({
            message: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined
            }
        });
    }

    // ---------------------------

    renderForm() {
        const { form } = this.state;

        if (null === form.note || undefined === form.note) {
            return null;
        }

        return (
            <PathNoteForm title={form.title}
                note={form.note}
                onSave={(a) => this.onNoteSave(a)}
                onHide={() => this.onNoteExit()} />
        );
    }

    renderTable(isWaiting) {
        if (isWaiting) {
            return (
                <Modal show={true} bsSize="large">
                    <Modal.Header>
                        <Modal.Title>Notas</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <LoadingSpinner />
                    </Modal.Body>
                </Modal>
            )
        }

        const { table } = this.state;

        const partialData = table.data.slice((table.page - 1) * table.elementsPerPage, table.page * table.elementsPerPage);

        return (
            <Modal show={true} bsSize="large">
                <Modal.Header>
                    <Modal.Title>Notas</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Grid fluid>
                        <Row>
                            <Col sm={12}>
                                <Table responsive striped hover style={{ marginTop: 10 }}>
                                    <thead>
                                        <tr>
                                            <th>Texto</th>
                                            <th>&nbsp;</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            partialData.map((data, idx) =>
                                                <tr key={`note-${idx}`}>
                                                    <td>{data.text}</td>
                                                    <td>
                                                        <ButtonToolbar className="pull-right">
                                                            <TableButton marginRight icon="icon-edit" title="Editar" onClick={() => this.onEditClick(data)} />
                                                            <TableButton icon="icon-trash" title="Eliminar" onClick={() => this.onDeleteClick(data)} />
                                                        </ButtonToolbar>
                                                    </td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </Table>

                                <PaginationBuilder
                                    currentPage={table.page}
                                    elementsPerPage={table.elementsPerPage}
                                    dataLength={table.data.length}
                                    onChangePage={(a) => this.onChangePage(a)}
                                    onChangeElementsPerPage={(a) => this.onChangeElementsPerPage(a)} />
                            </Col>
                        </Row>
                    </Grid>
                    <ButtonToolbar>
                        <Button onClick={() => this.onSave()}> GUARDAR ALTERAÇÕES </Button>
                        <Button onClick={() => this.props.onHide()}> CANCELAR ALTERAÇÕES </Button>
                        <Button className="pull-right" onClick={() => this.onAddClick()}> ADICIONAR </Button>
                    </ButtonToolbar>
                </Modal.Body>
            </Modal>
        );
    }

    render() {
        const { actions, message } = this.state;

        return (
            <div>
                {this.renderTable(actions.isLoading || actions.isUpdating)}
                {this.renderForm()}

                <HandleMessage
                    title={message.title}
                    message={message.message}
                    style={message.style}
                    icon={message.icon}
                    show={message.show}
                    onHide={() => this.onExitMessage()} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/datamanager/notes/PathNotes.js